import axios from 'axios';

const makeAThonAPI = '/api/makeAThon';

export default class ReportShareService {
  public getReportByUserId(userId: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(makeAThonAPI + '/report/find/' + userId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
